module.exports = __webpack_public_path__ + "media/icons/instagram-primary@3x-44804987.svg";